import { map, Observable } from 'rxjs';
import { CompanyModel, UserRoleCompany } from '../models/iam-dtos';
import { AuditUserCommand, CompanyModel as UsersApiCompanyModel, CompanyDto } from '../services/iamapi/iamapi.services';
import { IamWrapperConstants } from '../iamWrapperConstants';

export class AddLatestAccessedCompanyTransform {
  static transformOutput(response$: Observable<void>, userCompanies: CompanyDto[]): Observable<CompanyModel[]> {
    return response$.pipe(
      map(response =>
        userCompanies.slice(0, IamWrapperConstants.CompaniesPageSize).map(
          company =>
            new CompanyModel({
              companyId: company.companyId,
              companyName: company.companyName,
            }),
        ),
      ),
    );
  }
  static transformInput(userRoleCompany: UserRoleCompany, userObjectId: string, userCompanies: UsersApiCompanyModel[]): AuditUserCommand {
    const companyCode = userCompanies.find(company => company.companyId === userRoleCompany.companyId).name;
    return new AuditUserCommand({
      userObjectId,
      companyCode,
    });
  }
}
